module.exports = __webpack_public_path__ + "img/evonik-logo.d6d17344.jpg";